import React, { useState, useEffect } from 'react';

function UploadData () {
    const [mvFile, setMvFile] = useState(null)
    const [dvFile, setDvFile] = useState(null)
    const [uploadMvClicked, uploadMv] = useState(false)
    const [uploadDvClicked, uploadDv] = useState(false)
    const [uploading, setUploading] = useState(false)

    useEffect(() => {
        setUploading(true)
        if (uploadMvClicked) {
            fetch("https://mv.cylee.xyz/uploadMobiusData", {
                method: "PUT",
                headers: {
                    "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                },
                body: mvFile
            }).then((result) => {
                if (result.ok) {
                    alert("File successfully uploaded!!")
                } else {
                    alert("File could not be uploaded! " + result)
                }
            }).catch((err) => {
                alert("Error!! "+ err)
            }).finally(() => {
                setUploading(false)
            })

            uploadMv(false)
        }
        if (uploadDvClicked) {
            fetch("https://mv.cylee.xyz/uploadDriverData", {
                method: "PUT",
                headers: {
                    "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                },
                body: dvFile
            }).then((result) => {
                if (result.ok) {
                    alert("File successfully uploaded!!")
                } else {
                    alert("File could not be uploaded! " + result)
                }
            }).catch((err) => {
                alert("Error!! "+ err)
            }).finally(() => {
                setUploading(false)
            })

            uploadDv(false)
        }
        
        setUploading(false)
    }, [uploadMvClicked, uploadDvClicked])


    const handleMvFileChange = (e) => {
        if (e.target.files) {
            setMvFile(e.target.files[0])
        }
    }

    const handleMobiusUpload = () => {
        uploadMv(true)
    }
    
    const handleDvFileChange = (e) => {
        if (e.target.files) {
            setDvFile(e.target.files[0])
        }
    }

    const handleDriverUpload = () => {
        uploadDv(true)
    }

    return (
        <section className='UploadData'>
            <div className='Mobius'>
                <text>
                    Upload Mobius Task Report
                </text>
                <br />
                <input id='UploadMobius' type='file' onChange={handleMvFileChange} />
                <br />
                {mvFile && (
                    <button onClick={handleMobiusUpload} className='UploadMobius'>
                        Upload
                    </button>
                )}
            </div>
            <br />
            <div className='Driver'>
                <text>
                    Upload Driver Report
                </text>
                <br />
                <input id='UploadDriver' type='file' onChange={handleDvFileChange} />
                <br />
                {dvFile && (
                    <button onClick={handleDriverUpload} className='UploadDriver'>
                        Upload
                    </button>
                )}
            </div>
            <br />
            {uploading && (
                <text>Uploading! Please wait...</text>
            )}
        </section>
    )
}

export default UploadData